import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Result = ({ outcome, oddsDesc }) => (
    <div className="js-PC-runnerRow">
        <div className="PC-bestOddsContainer">
            <div
                className={classNames(
                    'ui-btn',
                    'tn-result'
                )}
            >
                <span
                    className={classNames(
                        'tn-result__outcome',
                        { 'tn-result__outcome_NR': outcome === 'NR' }
                    )}
                >
                    {outcome}
                </span>
                {
                    (outcome !== 'NR') && (
                        <span className="tn-result__odds-desc">{oddsDesc}</span>
                    )
                }
            </div>
        </div>
    </div>
);

Result.propTypes = {
    outcome: PropTypes.string.isRequired,
    oddsDesc: PropTypes.string.isRequired,
};

export default Result;



// WEBPACK FOOTER //
// ./src/js/Result/index.js